enum MODES {
  // used when the an Order has been created from a Tire Rack order
  // and will be completed via CS Portal
  FINISH = 'finish', //this is not being used because we do not have TireRack Orders yet. This functionality might be needed when we implement DTMI Integrated Scheduler. Will leave.
  EDIT = 'edit', //when an order is being edited from within the 'Edit Order' module
  SCHEDULER = 'scheduler', //when an order is being scheduled from the main google search bar
}

export { MODES }
